module.exports = __webpack_public_path__ + "img/icon-4.fa85206d.png";